export default __webpack_public_path__ + "static/media/G_wdt_c_cap_2.400155c8.mp3";